import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { business, fourCs, photos } from '../data/site';
export function EastEndWay() {
  return <section id="the-east-end-way" className="w-full bg-white py-20 lg:py-28" data-id="element-69" data-mp="3f9wkke80dadk">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-70" data-mp="3k3r0r7oen77w">
        <div className="grid gap-14 lg:grid-cols-[minmax(0,1fr)_minmax(0,460px)] lg:items-start lg:gap-20" data-id="element-71" data-mp="3o3t4rnhm4cqc">
          <div data-id="element-72" data-mp="2rebq4j0njgci">
            <p className="text-[12px] font-bold uppercase tracking-[0.18em] text-brand-dark" data-id="element-73" data-mp="2rek0o49ay9kj">
              Our approach
            </p>
            <h2 className="mt-4 font-display text-[34px] font-extrabold leading-[1.08] tracking-[-0.02em] text-ink sm:text-[42px] lg:text-[48px]" data-id="element-74" data-mp="2wd54ednrjbdq">
              The East End Automotive Way
            </h2>
            <p className="mt-6 max-w-[640px] text-[17px] leading-relaxed text-steel/80" data-id="element-75" data-mp="35bgr44lidp0w">
              Anyone can replace a part. Our work starts with communication —
              an honest, professional opinion about what your vehicle actually
              needs, explained clearly enough that you can weigh the options
              yourself. We would rather educate you and recommend the right
              solution than sell you a repair you did not need.
            </p>

            <ol className="mt-12 space-y-0 border-t border-black/10" data-id="element-76" data-mp="1f6ueu75lejth">
              {fourCs.map((step, i) => <li key={step.label} className="grid grid-cols-[auto_minmax(0,1fr)] gap-5 border-b border-black/10 py-6 sm:gap-7" data-id="element-77" data-mp="1a92j121tudk0" data-mpi={i}>
                  <span aria-hidden="true" className="mt-1 flex h-9 w-9 items-center justify-center rounded-md bg-ink font-display text-sm font-bold text-brand-light" data-id="element-78" data-mp="11ffvu0boqimf">
                    {i + 1}
                  </span>
                  <div data-id="element-79" data-mp="miosjfyw4mrj">
                    <h3 className="font-display text-xl font-bold tracking-tight text-ink" data-id="element-80" data-mp="miyij3jxqtx8">
                      {step.label}
                    </h3>
                    <p className="mt-1.5 max-w-[560px] text-[15px] leading-relaxed text-steel/75" data-id="element-81" data-mp="7wjc4y60z40r">
                      {step.copy}
                    </p>
                  </div>
                </li>)}
            </ol>

            <div className="mt-10 flex flex-col gap-5 sm:flex-row sm:items-center" data-id="element-82" data-mp="3v324mhln5ymq">
              <a href={business.phoneHref} className="inline-flex shrink-0 items-center justify-center gap-2.5 whitespace-nowrap rounded-md bg-ink px-6 py-3.5 text-base font-bold text-white transition-colors duration-150 ease-out hover:bg-steel" data-id="element-83" data-mp="3wh7qh8wnwhs">
                <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-84" data-mp="hu5vbwucxhqj" />
                Call {business.phone}
              </a>
              <p className="max-w-[340px] text-[15px] font-medium leading-snug text-steel/70" data-id="element-85" data-mp="msh6cawe1yac">
                Give us a call today to learn more about the East End
                Automotive Way!
              </p>
            </div>
          </div>

          <div className="grid gap-5 sm:grid-cols-2 lg:sticky lg:top-28 lg:grid-cols-1" data-id="element-86" data-mp="1oowl9zib2yb0">
            <figure data-id="element-87" data-mp="1ko2wz50ybhhl">
              <img src={photos.diagnosticMercedes} alt="Mercedes-Benz connected to diagnostic equipment in the service bay" className="aspect-[4/3] w-full rounded-lg object-cover object-[center_28%]" data-id="element-88" data-mp="1komggq692dxq" />
              <figcaption className="mt-2.5 text-[13px] text-steel/60" data-id="element-89" data-mp="15qkcwfz7xsgh">
                Testing until the cause is confirmed, not assumed.
              </figcaption>
            </figure>
            <figure data-id="element-90" data-mp="11r1ovbc3p19f">
              <img src={photos.consultation} alt="Technician explaining the confirmed diagnosis and repair options to a customer at the vehicle" className="aspect-[4/3] w-full rounded-lg object-cover object-center" data-id="element-91" data-mp="1fogm328lidby" />
              <figcaption className="mt-2.5 text-[13px] leading-snug text-steel/60" data-id="element-92" data-mp="2r5q2th0car9k">
                Once we confirm the diagnosis, we explain the issue and your
                repair options clearly.
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>;
}